export default {
  title: 'Activity',
  participant_followed: '{name} is following you',
  presentation_bookmarked: '{name} bookmarked your {presentation}',
  presentation_commented: '{name} commented your {presentation}',
};
